"use client";

import { useRouter, useSearchParams } from "next/navigation";

interface SortSelectProps {
  currentSort: string;
}

export default function SortSelect({ currentSort }: SortSelectProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const sortOptions = [
    { value: "age:newest", label: "Newest First" },
    { value: "age:oldest", label: "Oldest First" },
    { value: "price:lowest", label: "Lowest Price" },
    { value: "price:highest", label: "Highest Price" },
  ];

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("sort", e.target.value);
    params.delete("page");
    router.push(`/inventory?${params.toString()}`);
  };

  return (
    <select
      name="sort"
      id="sort"
      value={currentSort}
      onChange={handleChange}
      className="text-sm border border-zinc-300 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-red-500"
    >
      {sortOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
